import React, {useState, useEffect} from 'react'
import Header from '../Header';
import Main from '../Main';
import Upvote from './Upvote'
 
import '../App.css';
import '../theme-7.css';
import '../custom.css'
 
import firebase from '../firebase'
import moment from 'moment';
 
 
 
 
const PodcastList = () => {
  const [podcasts, setPodcasts] = useState([])
  const [actions, setActions] = useState(0)
  function usePodcasts() {
    useEffect(() => {
      loadPodcast()
    }, [])
 
    return podcasts
  }
 
  const loadPodcast = () => {
    firebase
    .firestore()
    .collection('podcasts')
    .orderBy('upvotes', 'desc')
    .onSnapshot((snapshot) => {
        const newPodcasts = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
        }))
 
        setPodcasts(newPodcasts)
    })
  }
 
  const apUpvotes = (podcasts) => {
    //const currPodData = firebase.firestore.collection('podcasts').doc(podcasts.id)
    //console.log(currPodData)
    //const [votes, setVotes] = React.useState(podcasts.upvotes + 1)
    console.log(actions)
    if (actions <=5 ){
    podcasts.upvotes += 1
    console.log('test')
    console.log(podcasts.upvotes)
    console.log(podcasts.upvotes + 1)
    console.log('teeegee')
    console.log(podcasts.id)
    //const changeUpvotes = podcasts.upvotes + 1
    const db = firebase.firestore()
    db.collection('podcasts').doc(podcasts.id).set({...podcasts})
    setActions(actions+1)
    loadPodcast() } else {
      return
    }
  }
 
 
 
  const m = moment().format("dddd, MMM Mo YYYY")
  usePodcasts()
  console.log('hi')
  console.log(podcasts)
 
  return (
    <div class="main-wrapper">
 
      <section class="pb-0 pt-5" style={{backgroundcolor: '#ffffff'}}>
        <div class=" px-5 text-center">
          <h2 class="heading">Featured Podcasts</h2>
          <div class="intro"> {m} </div>
          <form class="signup-form form-inline justify-content-center pt-3">
          </form>
        </div>
      </section>
 
      <section class="blog-list px-5 py-5 p-md-5">
        <div class="container">
                <div class="item mb-5">  
                {podcasts.map((pod) =>
                    <div key={pod.id} class="media" style={{marginBottom: "69px"}}>
                      <button onClick={() => apUpvotes(pod)} podcasts={pod} style={{
                      height: 70,
                      width: 70,
            backgroundColor: "#ffffff",
            borderRadius: "6px",
            }} class="mr-5 mt-4" type="button">
              <i class="fas fa-caret-up"></i>
              <br></br>
            <a style={{color: "#2f3542", fontSize: 20}}>{ pod.upvotes }</a>
        </button>
                        <img class="mr-3 img-fluid post-thumb d-none d-md-flex" src={pod.imgurl} alt="image" />
                        <div class="media-body" style={{backgroundColor: "#ffffff"}}>
                          <h3 class="title mb-1 text-left px-4 "><a href="blog-post.html">{ pod.title }</a></h3>
                          <div class="intro text-left px-4 ">{ pod.desc }</div>
                        </div>
                    </div>
                    )}
                </div>
        </div>
      </section>
 
 
    </div>
  );
}
 
export default PodcastList